export function buildUrlWithParams(baseUrl: string, params: Record<string, string>): string {
  const url = new URL(baseUrl, window.location.origin)
  const search = new URLSearchParams(url.search)
  for (const [key, value] of Object.entries(params)) {
    if (value != null) search.set(key, value)
  }
  url.search = search.toString()
  return url.toString()
}
